export const PATH = {
  EMPTY_IO_LIST: '/',
  IO_LIST: '/io-list',
  IO_DETAIL: '/io-detail',
  CAMPAIGN_CTEATE: '/campaign-create',
  CAMPAIGN_EDIT: '/campaign-edit',
  CAMPAIGN_SAVING: '/campaign-saving',
};
